const PREFIX = "@HIGHGROUND_GLOBAL_";

export const SEGMENT_DETAIL = `${PREFIX}SEGMENT_DETAIL`;
